import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { buttonTypes } from 'src/app/shared/constants/commonenums';
import { operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { Utilities } from 'src/app/shared/utilities/utilities';

@Component({
  selector: 'app-open-booking-slot-view',
  templateUrl: './open-booking-slot-view.component.html',
  styleUrls: ['./open-booking-slot-view.component.scss']
})
export class OpenBookingSlotViewComponent implements OnInit, OnDestroy {
  @Input() allAvailableSlots: [];
  @Input() maxDuration;
  @Input() minDuration;
  @Input() isenableMultiple;
  @Output() SlotChanged = new EventEmitter<any>();
  isMultiSlotSelection: boolean;
  Subscriptions: Subscription = new Subscription();
  buttonType = buttonTypes;
  anyMemberAllocationTypeId: number;
  constructor(public gs: GuestService) { }

  ngOnInit(): void {
    this.gs.slotAvailabilitySubject$.subscribe(data => {
      this.setSlots(true);
    })

    this.Subscriptions.add(this.gs.restaurantWidgetSettings$.subscribe(value => {
      this.isMultiSlotSelection = value.EnableMultiSlotSelection;
      console.log(this.gs.membershipId);
    }));

    this.isMultiSlotSelection = true;
    this.IsMember();
  }

  setSlots(isSlotsAvailable) {

    if (this.gs.slots_holder !== undefined) {
      this.gs.slots_holder.sort((a, b) => Utilities.parseDateString(a.DateTime).getTime() - Utilities.parseDateString(b.DateTime).getTime());
    }
    if (!this.gs.slots_holder) {
      return;
    }
    let newslots = this.gs.slots_holder.filter((slot) => !slot.IsDisabled && (!slot.IsOverRide));
    let allslots = this.gs.slots_holder.filter((slot) => !slot.IsDisabled && (slot.IsOverRide));
    if (isSlotsAvailable) {
      this.gs.allAvailableSlots = this.gs.slots_holder;
    } else {
      this.gs.allAvailableSlots = newslots;
    }

  }

  selectedOpenBookingResevationSlots(slot) {
    if (this.minDuration) {
      this.selectedPrivateBookingResevationSlots(slot);
    } else {
      this.openBookingSlotChange(slot);
    }
  }



  selectedPrivateBookingResevationSlots(slot) {

    var mins = this.gs.restaurantWidgetSettings$.value.TimeSlotUnitInMinutes;
    let timediff = mins;
    if (this.isMultiSlotSelection) {
      var isContinuous: boolean = false;
      var allKeys = [];
      for (var key in this.gs.selectedOpenBookingSlots) {
        if (this.gs.selectedOpenBookingSlots[key] == true) {
          allKeys.push(key);
        }
      }
      var slotsToCheck = this.gs.slots_holder.filter(x => allKeys.includes(x.Id.toString()));
      var slotList = slotsToCheck.filter(x => x.Id != slot.Id);

      if (this.gs.selectedOpenBookingSlots[slot.Id] == true) {
        if (slotList.length == 1) {
          isContinuous = true;
        }
        for (var i = 0; i < slotList.length - 1; i++) {
          if (slotList[i]) {
            const diffInMins = Math.abs(Utilities.diffBetweenDatesInMinutes(slotList[i].DateTime, slot.DateTime))
            if (diffInMins == mins) {
              isContinuous = true;
              timediff = timediff + diffInMins;
            }
            else {
              isContinuous = false;
              break;
            }
          }
        }
      }
      else {
        for (var key in this.gs.selectedOpenBookingSlots) {
          if (this.gs.selectedOpenBookingSlots[key] == true) {
            var slotValue = this.gs.slots_holder.filter(x => x.Id == key);
            if (slotValue && slotValue.length > 0) {
              const diffInMins = Math.abs(Utilities.diffBetweenDatesInMinutes(slotValue[0].DateTime, slot.DateTime));
              if (diffInMins == mins) {
                isContinuous = true;
                for (var i = 0; i < slotList.length - 1; i++) {
                  if (slotList[i]) {
                    const diffInSlotMins = Math.abs(Utilities.diffBetweenDatesInMinutes(slotList[i].DateTime, slotList[i + 1].DateTime))
                    if (diffInSlotMins == mins) {
                      timediff = timediff + diffInSlotMins;
                    } else {
                      timediff = mins;
                    }
                  }
                }
              }

            }
          }
        }
      }
      if (isContinuous) {
        timediff = timediff + mins;
        if (timediff <= this.maxDuration) {
          this.gs.selectedOpenBookingSlots[slot.Id] = !this.gs.selectedOpenBookingSlots[slot.Id];
        }
        else {
          this.gs.selectedOpenBookingSlots[slot.Id] = false;
        }
      } else {
        this.gs.selectedOpenBookingSlots[slot.Id] = !this.gs.selectedOpenBookingSlots[slot.Id];
      }
    } else {
      this.gs.selectedOpenBookingSlots = {};
      this.gs.selectedOpenBookingSlots[slot.Id] = !this.gs.selectedOpenBookingSlots[slot.Id];
    }
    this.SlotChanged.emit();
  }

  openBookingSlotChange(slot) {
    var mins = this.gs.restaurantWidgetSettings$.value.TimeSlotUnitInMinutes;
    if (this.gs.editPartyData$.value && this.gs.operation === operationType.edit && !this.isenableMultiple) {
      if (this.isMultiSlotSelection) {
        var isContinuous: boolean = false;
        var allKeys = [];
        for (var key in this.gs.selectedOpenBookingSlots) {
          if (this.gs.selectedOpenBookingSlots[key] == true) {
            allKeys.push(key);
          }
        }
        var slotsToCheck = this.gs.slots_holder.filter(x => allKeys.includes(x.Id.toString()));

        if (this.gs.selectedOpenBookingSlots[slot.Id] == true) {
          var slotList = slotsToCheck.filter(x => x.Id != slot.Id);
          if (slotList.length == 1) {
            isContinuous = true;
          }
          for (var i = 0; i < slotList.length - 1; i++) {
            if (slotList[i]) {
              if (Math.abs(Utilities.diffBetweenDatesInMinutes(slotList[i].DateTime, slotList[i + 1].DateTime)) == mins) {
                isContinuous = true;
              }
              else {
                isContinuous = false;
                break;
              }
            }
          }
        }
        else {
          for (var key in this.gs.selectedOpenBookingSlots) {
            if (this.gs.selectedOpenBookingSlots[key] == true) {
              var slotValue = this.gs.slots_holder.filter(x => x.Id == key);
              if (slotValue && slotValue.length > 0) {
                if (Math.abs(Utilities.diffBetweenDatesInMinutes(slotValue[0].DateTime, slot.DateTime)) == mins) {
                  isContinuous = true;
                }

              }
            }
          }
        }
        if (!isContinuous) {
          this.gs.selectedOpenBookingSlots = {};
        }
      }
    }
    if (!this.isMultiSlotSelection) {
      this.gs.selectedOpenBookingSlots = {};
    }
    this.gs.selectedOpenBookingSlots[slot.Id] = !this.gs.selectedOpenBookingSlots[slot.Id];
    this.SlotChanged.emit();
  }
  IsMember(){
    if(!this.gs.restaurantWidgetSettings$.value.AllocationMappings)return false;
    let allocationType = this.gs.restaurantWidgetSettings$.value.AllocationMappings;
    let isAnyMember = allocationType.find(type => type.AllocationTypeName === 'AnyMembers');
    this. anyMemberAllocationTypeId = isAnyMember ? isAnyMember.AllocationTypeId : null;
  }
  ngOnDestroy(): void {
    if (this.Subscriptions) { this.Subscriptions.unsubscribe(); }
  }
}
